if (typeof define === "function" && define.amd) {
    define('landing',['Controls/Ready', 'jquery'], function (Ready) {
        //Определение браузера----------------------------------------------------------------
        var BrowserDetect = {
            init: function() {
                this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
                this.OS = this.searchString(this.dataOS) || "an unknown OS";
            },
            searchString: function(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1)
                            return data[i].identity;
                    } else if (dataProp)
                        return data[i].identity;
                }
            },
            searchVersion: function(dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [{
                string: navigator.vendor,
                subString: "Apple",
                identity: "Safari",
                versionSearch: "Version"
            }, {
                string: navigator.userAgent,
                subString: "Trident",
                identity: "Internet Explorer",
                versionSearch: "rv"
            }, {
                string: navigator.userAgent,
                subString: "Gecko",
                identity: "Mozilla",
                versionSearch: "rv"
            }, {
                /* For Older Netscapes (4-) */
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }],
            dataOS: [{
                string: navigator.platform,
                subString: "Win",
                identity: "Windows"
            }, {
                string: navigator.platform,
                subString: "Mac",
                identity: "Mac"
            }, {
                string: navigator.userAgent,
                subString: "iPhone",
                identity: "iPhone"
            }, {
                string: navigator.platform,
                subString: "Linux",
                identity: "Linux"
            }]

        };

        function lazyLoadsInit() {
            var $lazyLoads = $('.j-lazy-load');
            if ($lazyLoads.length > 0) {
                require(['jquery', 'Controls/LazyLoad'], function ($, LazyLoad) {
                    var obLazyLoad = new LazyLoad($lazyLoads);
                    obLazyLoad.init();
                });
            } else {
                $.event.trigger({
                    type: 'lazyLoadReceived',
                    data: []
                });
            }
        }

        function enableOnIphone() {
            BrowserDetect.init();
            if (BrowserDetect.OS.toLowerCase() === 'iphone' || BrowserDetect.OS.toLowerCase() === 'mac') {
                $("body,html").addClass("is-"+ BrowserDetect.OS.toLowerCase()).addClass("is-" + BrowserDetect.browser.toLowerCase());
            }
        }

        enableOnIphone();




        var compositeFinished;
        (function () {
            var df = $.Deferred();
            if (window.frameCacheVars !== undefined) {
                BX.addCustomEvent("onFrameDataReceived", function () {
                    df.resolve();
                });
            } else {
                df.resolve();
            }
            compositeFinished = function (fn) {
                if (typeof fn == 'function') df.done(fn);
                return df.promise();
            }
        })();

        function startSelects() {
            if ($('.j-select').length) {
                require(['cusel'], function () {
                    var params = {
                        changedEl: ".j-select",
                        visRows: 6,
                        scrollArrows: true
                    };
                    try {
                        cuSel(params);
                    }catch (e) {
                        console.error(e.getMessage())
                    }

                    $(document).data('jSelectInit', true);
                    $(document).trigger("jSelect.init");
                });
            } else {
                $(document).data('jSelectInit', true);
                $(document).trigger("jSelect.init");
            }

            var $relatedSelects = $('.j-related-selects');
            if ($relatedSelects.length) {
                $(document).on("jSelect.init", function () {
                    $('.j-related-selects').each(function () {
                        var $item = $(this);
                        require(['Controls/RelatedSelects'], function (RelatedSelects) {
                            new RelatedSelects({
                                select1: $item
                            });
                        });
                    });
                });
            }
        }

        function textScrollStart() {
            var $textScroll = $('.j-text-scroll');
            if ($textScroll.length) {
                $textScroll.each(function () {
                    var $item = $(this);
                    require(['Controls/TextScroll'], function (TextScroll) {
                        new TextScroll($item);
                    });
                });
            }
        }

        function startPopups(context) {
            var fancyboxGroup = $(".fancybox", context).add('[rel = prettyPhoto]', context).add('[rel = group]', context);
            if (fancyboxGroup.length > 0) {
                require(['fancybox'], function () {
                    fancyboxGroup.fancybox();
                });
            }
            var $fancybox = $('.j-fancybox', context);
            var $popupLink = $('.j-popup-link', context);

            if ($fancybox.length > 0 || $popupLink.length > 0) {
                require(['jquery', 'fancybox', 'cusel'], function ($) {
                    if ($fancybox.length > 0) {
                        $fancybox.fancybox({
                            padding: 40
                        });
                    }
                    if ($popupLink.length > 0) {
                        $popupLink.fancybox({
                            fitToView: false,
                            padding: 0,
                            arrows: false,
                            closeBtn: false,
                            afterLoad: function () {
                                $(".j-close").live("click", function () {
                                    $.fancybox.close(true);
                                });
                            },
                            afterShow: function () {
                                var id = '';
                                $('.fancybox-wrap .cusel input').each(function (i) {
                                    if (i != 0) id += ',';
                                    id += '#' + $(this).attr('id');
                                });
                                var params = {
                                    refreshEl: id,
                                    visRows: 6,
                                    scrollArrows: true
                                };
                                cuSelRefresh(params);
                            }
                        });
                    }
                });
            }
        };

        function startSpoiler(context) {
            var $spoiler = $('.j-spoiler', context);
            if ($spoiler.length) {
                $spoiler.each(function () {
                    var $item = $(this);
                    require(['Controls/Spoiler'], function (Spoiler) {
                        new Spoiler($item);
                    });
                });
            }
        }

        function loadLozad() {
            // lazyload img
            requirejs(['lozad'], function (lozad) {
                var observer = lozad('.lozad', {
                    rootMargin: `${window.innerHeight}px 0px ${window.innerHeight}px 0px`,
                });
                observer.observe();
            });

        }

        function startSwiper() {
            function swiperInitialize(selector, swiperObject, callback){
                require(['swiper'], function (Swiper) {
                    const Slider = new Swiper(selector, swiperObject);
                    if(callback && typeof callback === "function") callback(Slider);
                });
            }

            if($(".vector__swiper-container").length) {
                var swiperObject = {
                    slidesPerView: 1,
                    allowTouchMove: false,
                    simulateTouch: false,
                    effect: 'fade',
                    autoHeight: true,
                    initialSlide: 1,
                }

                swiperInitialize(".vector__swiper-container", swiperObject, function (vector) {
                    $('[data-vector-list] li').each(function(index) {
                        const $el = $(this);

                        $el.click(function() {
                            vector.slideTo(index);
                            $('[data-vector-list] li').removeClass('active');
                            $el.addClass('active');
                        });
                    });

                    $('[data-vector-select]').click(function() {
                        const $list = $(this).siblings($('[data-vector-listm]'));
                        $list.toggleClass('closed');
                        $(this).toggleClass('closed');
                    });
                });

            }

            if ( $('.vendor__swiper-container').length) {
                var swiperObject = {
                    slidesPerView: 2,
                    spaceBetween: 32,
                    navigation: {
                        disabledClass: 'vendor__swiper-button_disabled',
                        nextEl: '.vendor__swiper-button_next',
                        prevEl: '.vendor__swiper-button_prev',
                    },
                    breakpoints: {
                        200: {
                            slidesPerView: 1,
                        },
                        600: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 5,
                        },
                    },
                };

                swiperInitialize('.vendor__swiper-container', swiperObject);
            }

            if ($('.about__swiper-container').length) {
                var swiperObject = {
                    slidesPerView: 1,
                    allowTouchMove: true,
                    simulateTouch: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    autoHeight: true,
                    navigation: {
                        nextEl: '.about__navigation--next',
                        prevEl: '.about__navigation--prev',
                    },
                    pagination: {
                        clickable: true,
                        el: '.about__pagination',
                    },
                    breakpoints: {
                        600: {
                            allowTouchMove: false,
                            simulateTouch: false,
                        },
                    },
                };

                swiperInitialize('.about__swiper-container', swiperObject, function (about) {
                    $('[data-about-list] li').each(function(index) {
                        const $el = $(this);
                        $el.click(function() {
                            about.slideTo(index);
                            $('[data-about-list] li').removeClass('active');
                            $el.addClass('active');
                        });
                    });
                });

            }


        };

        function formStart(context) {
            var $formPopup = $('.j-form-popup', context);
            if ($formPopup.length) {
                $formPopup.each(function () {
                    var $item = $(this);
                    require(['Controls/Form/FormPopupMng'], function (FormPopupMng) {
                        var obFormPopup = new FormPopupMng({
                            root: $item
                        });
                        var globalName = obFormPopup.getGlobalName();
                        window[globalName] = obFormPopup;
                        obFormPopup.init();
                        $item.trigger("jFormPopup.init");
                    });
                });
            }

            var $formPage = $('.j-form-page', context);
            if ($formPage.length) {
                $formPage.each(function () {
                    var $item = $(this);
                    require(['Controls/Form/FormPageMng'], function (FormPageMng) {
                        var obFormPage = new FormPageMng({
                            root: $item
                        });
                        var globalName = obFormPage.getGlobalName();
                        window[globalName] = obFormPage;
                        obFormPage.init();
                        $item.trigger("jFormPage.init");
                    });
                });
            }
        };

        function startOwlCarousel(context){
            $('.j-owl-carousel', context).each(function () {
                var item = $(this);
                require(['Controls/OwlCarousel2'], function (OwlCarousel2) {
                    new OwlCarousel2(item);
                });
            })
        };

        loadLozad();
        startSwiper();

        if($('.scanner-type').length) {
            $('.type').on('click', function(e){
                e.preventDefault();
                var destination = $(this).attr('href');
                var $target = $(destination).offset().top;
                $('html,body').stop().animate({ scrollTop: $target }, 1000);

            });
        }


        if ($('#geo_confirm').length) {
            if (/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() < 980){
                $('body').prepend($('#geo_confirm'));
                $('body').append('<div class="fancybox-overlay fancybox-overlay-fixed geo-confirm-overlay"></div>');
                $(document).mouseup(function (e) {
                    var div = $("#geo_confirm");
                    if (!div.is(e.target) && div.has(e.target).length === 0) {
                        $('.geo-confirm-overlay').remove();
                        $('#geo_confirm').find('.close').click();
                    }
                });
                $('.j-city-popup').on('click', function () {
                    $('#geo_confirm').find('.close').click();
                });
                $('.confirm-btn').on('click', function () {
                    $('.geo-confirm-overlay').remove();
                });
                $('#geo_confirm .close').on('click', function () {
                    $('.geo-confirm-overlay').remove();
                });
            }
        }


        window.extend = function (Child, Parent) {
            var F = function () {
            };
            F.prototype = Parent.prototype;
            Child.prototype = new F();
            Child.prototype.constructor = Child;
            Child.superclass = Parent.prototype;
        }

         window.getInitial=function(el, defName, eventTrigger, dataTrigger) {
            if (!(el instanceof jQuery)) {
                throw new Error("Invalid argument - is not jquery object");
            }
            if (typeof defName == 'undefined') {
                defName = 'initDeferred';
            }
            var defer = el.data(defName);

            if (!defer) {
                defer = $.Deferred();
                el.data(defName, defer);
            }
            el.on(eventTrigger, function () {
                defer.resolve();
            });
            if (el.data(dataTrigger)) {
                defer.resolve();
            }
            return defer;
        }

        $(document).on("onMainInit", function (event) {
            var context = event.contextContainer;
            //Заполняем скрытый инпут форм
            var $sessid = $('form #sessid', context);
            if ($sessid.length > 0) {
                $sessid.val(BX.bitrix_sessid());
            }
            $(document).ready(function(){
               $('.header-row__search-link').unbind().click(function(e){
                e.preventDefault();
                $('.header-search-wrapper').slideToggle();
              });
            });
            (function () {
                function e() {
                    window.pageYOffset > o ? (i.addClass("sticky"), $(".bit-menu__postfix-menu").height(i.height(), $(".js-menu-main").addClass("menu-sticky")).addClass("show")) : (i.removeClass("sticky"), $(".bit-menu__postfix-menu").removeClass("show"), $(".js-menu-main").removeClass("menu-sticky"))
                }
                window.onscroll = e;
                var i = $(".bit-floating-wrapper"), o = i.position().top;
                $(window).on('resize', function(){
                  var win = $(this);
                  if (win.width() >= 990) {
                    $('.menu__list').attr('style', '');
                    $('.biti-burger_blue').removeClass('active');
                  }
                });

            })();

            $(function(){
                $('.biti-burger_blue').unbind().click(function(){
                    $('.biti-burger_blue').toggleClass('active');
                    $(".menu__list").slideToggle();
                    $('body').toggleClass('body-not-scroll');
                });
            });


            var $deffered = $('.j-deffered', context);
            if ($deffered.length > 0) {
                require(['Controls/DeferredDataMng'], function (DeferredDataMng) {
                    var obDeffered = new DeferredDataMng($deffered);
                    obDeffered.init();
                    context = $(context).add(obDeffered.items);
                });

            }

            startOwlCarousel(context);

;

            if (/iPhone/.test(navigator.userAgent) && !window.MSStream)
            {
                $(document).on("focus", "input, textarea, select", function()
                {
                    $('meta[name=viewport]').remove();
                    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">');
                });

                $(document).on("blur", "input, textarea, select", function()
                {
                    $('meta[name=viewport]').remove();
                    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">');
                });
            }


            // добавляем отправку событий в Яндекс и Гугланалитику
            require(['Controllers/SeoTrackHelper'], function(SeoTrackHelper) {

                // window.Ya._metrika.counters
                let yandex_counter = window.yaCounter11881714;

                if (location.hostname.match('.kz') || (window.location.href.indexOf('kazakhstan') > -1)) {
                    yandex_counter = window.yaCounter46772403;
                }

                window.SeoTrackHelper = new SeoTrackHelper();
                window.SeoTrackHelper.counters = {
                    yandex: yandex_counter
                }

                window.SeoTrackHelper.goalsData = {
                    'send-callHunter':{
                        'yandex': {
                            code: 'callHunter-send'
                        },
                    },
                    'send-61POPUP-REG':{
                        'yandex': {
                            code: 'event-send'
                        },
                    },
                    'send-120':{
                        'yandex': {
                            code: 'vacancy-send'
                        },
                    },
                    'send-111':{
                        'yandex': {
                            code: 'vacancy-send'
                        },
                    },
                    'send-172SERVICE_ORD':{
                        'yandex': {
                            code: 'phonelead-send'
                        },
                    },
                    'send-115COMPLAINTS_HEADER':{
                        'yandex': {
                            code: 'complaintboss-send'
                        },
                    },
                    'send-173BLOG_SUBSCRIBE':{
                        'yandex': {
                            code: 'subscribed'
                        },
                    },
                    'send-173ACTIONS_SUBSCRIBE':{
                        'yandex': {
                            code: 'subscribed'
                        },
                    },
                    'send-default':{
                        'yandex': {
                            code: 'form-send'
                        },
                    }
                }
            });
            // результат заполнения popup формыб цель определяем по маркеру формы
            $(document).on("form.result.popup.open", function (event, resultArr) {
                if(!resultArr.error) {
                    window.SeoTrackHelper.sendGoal('send',resultArr.formSalt);
                }
            });

            formStart(context);

            if ($('.content iframe[src*="youtube.com"]', context).length > 0) {
                require(['Controls/Youtube'], function (Youtube) {
                    new Youtube($('.content', context));
                });
            }

            function initializeDifferentList() {
                var $differentItems = $('.j-city, .j-product', context);
                if ($differentItems.length > 0) {
                    var $dlContext = $('.width', context);
                    $differentItems.each(function () {
                        var $item = $(this);
                        require(['Controls/DifferentList'], function (DifferentList) {
                            new DifferentList($item, $dlContext);
                        });
                    });
                }
            }
            compositeFinished(function () {
                initializeDifferentList();
            });

            var $floating = $('.j-floating', context);
            if ($floating.length > 0) {
                require(['Controls/Responsive'], function (obResponsive) {
                    obResponsive.one(['large'], 'in', function () {
                        $floating.each(function () {
                            var $item = $(this);
                            require(['Controls/FloatingBox'], function (FloatingBox) {
                                new FloatingBox($item);
                            });
                        });
                    });
                });
            }

            /*Всё остальное*/
            require(['main'], function () {
                require(['Controls/Responsive'], function (obResponsive) {
                    var $tabItemSelector = $('.tab-item--default');
                    if ($tabItemSelector.length) {
                        obResponsive.on(['medium', 'large'], 'in', function () {
                            $tabItemSelector.off();
                        });

                        obResponsive.on(['xsmall', 'small'], 'in', function () {
                            $tabItemSelector.on('click', function(event) {
                                event.preventDefault();
                                $(this).siblings('.bit-tabs__nav').toggleClass('is-opened');
                            });

                        });
                    }

                    var $priceGridBlock = $('.price-grid__block');
                    if ($priceGridBlock.length) {
                        var maxHeight = 100;
                        var maxHeightSub = 0;
                        var maxHeightDesc = 0;

                        $(".price-grid__block").each(function () {
                            var thisH = $(this).find('.price-grid__title').height();
                            if (thisH > maxHeight) {
                                maxHeight = thisH;
                            }
                        });

                        $(".price-grid__title").height(maxHeight);


                        $(".price-grid__subtitle").each(function () {
                            var thisH = $(this).height();
                            if (thisH > maxHeightSub) {
                                maxHeightSub = thisH;
                            }
                        });
                        $(".price-grid__subtitle").height(maxHeightSub);


                        $(".price-grid__desc").each(function () {
                            var thisH = $(this).height();
                            if (thisH > maxHeightDesc) {
                                maxHeightDesc = thisH;
                            }
                        });
                        $(".price-grid__desc").height(maxHeightDesc);

                    }

                });
            });


            startSpoiler(context);

            var inputFile = $('.about-tasks').find('.form-file');
            if(inputFile.length) {
                var inputSelector = inputFile.find('.form-file__file');
                var fileCaptionPlace = inputFile.find('.form-file__selected');


                inputSelector.on('change', function() {
                    var $this = $(this);
                    fileCaptionPlace.text($this.val());
                });

            }

            var $tab = $('.j-tab', context);
            if ($tab.length > 0) {
                require(['Controls/SimpleTabs'], function (SimpleTabs) {
                    new SimpleTabs({
                        root: $tab,
                        tabNav: '.j-tab-nav'
                    });
                });
            }

            /*
             * UI 444
             * */
            require(['scrollTo'], function () {
                $(document).on('click', '.effect-button__link', function(e) {
                    var link = $(this);
                    $.scrollTo(link.attr('href'), 500);
                });
            });

            startPopups(context);

            var $headerCityListConfirm = $('#header-city-list-confirm', context);
            if ($headerCityListConfirm.length > 0) {
                $headerCityListConfirm.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Всплывающая плашка (Выбор)', 1]);
                });
            }
            var $headerCityStrong = $('.header-city .strong', context);
            if ($headerCityStrong.length > 0) {
                $headerCityStrong.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Верхняя полоска', 1]);
                });
            }
            var $contactRigthBoxContainerCity = $('#contact-right-box-container .city', context);
            if ($contactRigthBoxContainerCity.length > 0) {
                $contactRigthBoxContainerCity.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Контактный блок', 1]);
                });
            }

            /*
             * Разное
             * */
            var $questionary = $('.j-questionary', context);
            if ($questionary.length > 0) {
                $questionary.each(function () {
                    var $item = $(this);
                    require(['Controls/Questionary'], function (Questionary) {
                        new Questionary($item);
                    });
                });
            }

    var $leaping = $('.j-leaping', context);
    if ($leaping.length > 0) {
        require(["Controls/Leaping"], function (Leaping) {
            $leaping.each(function () {
                new Leaping(this);
            });
        });
    }

    $('.j-phone', context).each(function () {
        var item = $(this);
        require(['Controls/Phone'], function (Phone) {
            new Phone(item);
        });
    });

    $(document).bind("ScreenFloatingShow", function() {
        if($(".header .width").find(".header-offices-cont").length==0) {
            $(".header .width").append($("#header-offices-parent").find(".header-offices-cont").clone());
            $(".header .header-offices-cont .header-offices").removeClass('j-leaping');
            var $shuffleOffices = $('.j-shuffle-offices', context);
            if ($shuffleOffices.size() > 0) {
                require(["Controls/ShuffleOffices"], function (ShuffleOffices) {
                    $shuffleOffices.each(function () {
                        new ShuffleOffices(this);
                    });
                });
            }
        }
    });

            var popoverBlock = $('.popover', context);
            if (popoverBlock.length > 0) {
                popoverBlock.webuiPopover({trigger: 'hover'});
            }
            /*
             * Trash
             */
            if ($('.table-present:not(.j-send-request) td', context)
                    .add('.j-submit', context)
                    .add('.j-submit2', context)
                    .add('.j-file', context)
                    .add('.close-action', context)
                    .add('.why-we-block', context)
                    .add('#userFile', context)
                    .add('.j-print', context).length > 0
            ) {
                require(['trash'], function () {
                    tablePresent();
                });
            }
        })
        ;

        Ready.lazyLoadRecived.then(function () {

		  // enable google recaptcha
            require(['Controls/ReCaptchaProvider'], function (ReCaptchaProvider) {
                new ReCaptchaProvider();
            });

            textScrollStart();
            startSelects();


        });

        $(function () {
            $.event.trigger({
                type: "onMainInit",
                initiatorEventType: 'ready',
                contextContainer: document
            });
        });
        if (window.frameCacheVars !== undefined) {
            BX.addCustomEvent("onFrameDataReceived", function () {
                //debugger;
            });
        }
        $(document).on("lazyLoadBlockUpdate", function (event) {
            $.event.trigger({
                type: "onMainInit",
                initiatorEventType: 'lazyLoadBlockUpdate',
                contextName: event.contextName,
                contextContainer: event.contextContainer
            });
        });

        $(document).on('OnManualOfficeSelect', function (e, data) {
            var
                officeName = data.officeName;

            if (officeName == '')
                officeName = data.officeId;

            window.track(['Клик', 'Ссылка выберите офис', officeName]);
        });

        $(document).on('onDefferedCopyComplete', function (e, data) {
            var context = e.contextContainer || document;
            startSwiper();
            startOwlCarousel(context);
            formStart(context);
            startSpoiler(context);
            startPopups(context);
            textScrollStart();
            startSelects();
       });

// $(document).ready



        function jivo_onOpen() {
            var tracker = ga.getAll()[0];
            var gCliendId = tracker.get('clientId');
            jivo_api.setCustomData([
                {
                    title: 'gCliendId',
                    content: gCliendId,
                }
            ]);
        }



        require(['Controls/UtmLog'], function (UtmLog) {
            (new UtmLog()).execute();
        });
        /*
        * Замена текста из параметров в url
        * */
        require(['Controls/ContentUrlReplace'], function (ContentUrlReplace) {
            (new ContentUrlReplace()).execute();
        });

        $(document).on('form.result.popup.open', function (event, data) {
          if (typeof sendGoal === "function") sendGoal('form_send');
        });

        window.onload = function() {
            // Прячем последние цифры телефона в указанных городах
            lazyLoadsInit();
            var hidePhones = function(hidePhoneList){
              for(var i = 0; i < hidePhoneList.length; i++){
                var currentItem = hidePhoneList[i];
                currentItem.classList.add('slice_phone_number');

                var sliceButton = document.createElement('span');
                sliceButton.classList.add('show_slice_phone');
                sliceButton.textContent = 'показать телефон';
                currentItem.append(sliceButton);

                currentItem.addEventListener('click', function(e){
                  var sliceButtonCurrent = this.querySelector('.show_slice_phone');
                  if(sliceButtonCurrent){
                    e.preventDefault();

                    this.classList.add('visible');
                    sliceButtonCurrent.remove();
                  }
                });
              }
            };

            var hidePhoneRoot = document.querySelector('.slice-phone-active');
            if(hidePhoneRoot){
              var hidePhoneList = document.querySelectorAll('.footer-contacts .box-phone-href, .phone, li.box-office-phone');
              hidePhones(hidePhoneList);
            }

            //удаляем теги ym-measure
            var parent = document.getElementById("LHE_iframe_PROPERTYDETAILTEXT0");
			if (parent) {
				var elements = parent.getElementsByTagName("ym-measure");
				for(var i=0;i<=elements.length-1;i++){
					elements[i].parentNode.removeChild(elements[i]);
				}
			}
        };


	return true;
    })
}
;
